<template>
  <div>
    <lab-header ref="alb_header" page-name="Research"></lab-header>
    <cramb-header page-name="Research" :path="path"></cramb-header>
    <div class="center">
      <div class="research clear">
        <div class="ResearchC" style="display: none">
          <li v-for="(item, index) in researchCenter" :key="index" style="padding-bottom: 20px;height: 100%">
            <p class="title" style="text-align: left"><b><span class="num" style="font-size: 18px">{{item.num}}</span>{{item.title}}</b></p>
            <div class="ResearchR1">
              <div style="text-align:center;padding: 20px">
                <img :src="item.imgUrl" :title="item.title" style="max-width: 800px;height: 100%; object-fit: contain">
                <div style="text-align:center;padding: 30px">{{item.chineseTitle}}</div>
              </div>
              <div style="text-align:left;">
                <em>{{item.text}}</em>
              </div>
              <div style="text-align:right;">
                <strong><span style="font-size:16px;">{{item.owner}}</span></strong>
              </div>
            </div>
          </li>
        </div>
        <div class="ResearchL" style="display: none">
          <li style="padding-bottom: 20px;">
            <div class="ResearchR1">
              <div style="text-align:left;font-size: 20px;font-weight:bold; color: #1f2329;padding-bottom: 20px">
                {{ researchLeft.title }}
              </div>
              <div style="text-align:center;">
                <img :src="researchLeft.imgUrl" align="" alt="" height="321" title="" width="800">
                <div style="text-align:center;padding: 30px">{{ researchLeft.chineseTitle }}</div>
              </div>
              <div style="text-align:left;font-size: 18px;color: #1f2329;padding-bottom: 20px">
                Abstract
              </div>
              <div style="text-align:left;font-size: 16px;color: #1f2329;">
                <em>{{ researchLeft.text }}</em>
              </div>
              <div style="text-align:left;font-size: 18px;color: #1f2329;padding-bottom: 20px;padding-top: 20px">
                Keywords
              </div>
              <div style="text-align:left;font-size: 14px;font-weight:bold;color: #1f2329;">
                <em>{{ researchLeft.keywords }}</em>
              </div>
              <div style="text-align:left;font-size: 18px;color: #1f2329;padding-bottom: 20px;padding-top: 20px">
                Authors
              </div>
              <div style="text-align:left;">
                <strong><span style="font-size:14px;">{{ researchLeft.owner }}</span></strong>
              </div>
            </div>
          </li>
        </div>
        <div class="ResearchL" style="display: block;">
          <li v-for="(item, index) in researchLeftList" :key="index" style="padding-bottom: 20px;height: 100%">
            <p class="title"><b><span class="num">{{item.mark}}</span> {{item.title}}</b></p>
            <div class="ResearchR1">
              <div style="text-align:center;">
                <img align="" alt="" height="100%" :src="item.imgReqUrl" title="" width="100%" style="object-fit: contain">
                <div style="text-align:center;">{{item.chineseTitle}}</div>
              </div>
              <div style="text-align:left;">
                <em>{{item.text}}</em>
              </div>
              <div style="text-align:right;">
                <strong><span style="font-size:16px;">{{item.owner}}</span></strong>
              </div>
            </div>
          </li>
        </div>
        <div class="ResearchR" style="display: block;">
          <li v-for="(item, index) in researchRightList" :key="index" style="padding-bottom: 20px;height: 100%">
             <p class="title"><b><span class="num">{{item.mark}}</span> {{item.title}}</b></p>
            <div class="ResearchR1">
              <div style="text-align:center;">
                <img align="" alt="" height="100%" :src="item.imgReqUrl" title="" width="100%" style="object-fit: contain">
                <div style="text-align:center">{{item.chineseTitle}}</div>
              </div>
              <div style="text-align:left;">
                <em>{{item.text}}</em>
              </div>
              <div style="text-align:right;">
                <strong><span style="font-size:16px;">{{item.owner}}</span></strong>
              </div>
            </div>
          </li>
        </div>
      </div>
    </div>
    <lab-footer></lab-footer>
  </div>
</template>

<script>

import LabHeader from '../components/public/LabHeader'
import LabFooter from '../components/public/LabFooter'
import CrambHeader from '../components/public/CrambHeader'
export default {
  name: 'Research',
  components: { CrambHeader, LabFooter, LabHeader },
  data () {
    return {
      path: [
        {
          name: 'Home',
          url: '/'
        },
        {
          name: 'Research',
          url: '/research'
        }
      ],
      researchCenter: [
        {
          num: '1) ',
          text: '',
          title: 'Design and Synthesis of Rosin-Based Pesticides.',
          owner: '',
          chineseTitle: '',
          desc: '2022-02',
          imgUrl: require('../assets/img/research/research1.png')
        },
        {
          num: '2) ',
          text: '',
          title: 'The Design of Intelligent Responsive Sustained-release Materials.',
          owner: '',
          chineseTitle: '',
          desc: '2019-01',
          imgUrl: require('../assets/img/research/research2.png')
        }
      ],
      researchLeft: [
        {
          num: '1)',
          text: '',
          title: 'Design and Synthesis of Rosin-Based Pesticides.',
          owner: '',
          chineseTitle: '',
          desc: '2022-02',
          imgUrl: require('../assets/img/research/research1.png')
        }
      ],
      researchRight: [
        {
          num: '2)',
          text: '',
          title: 'Research on Rosin-based Pesticide Development and Action Mechanisms.',
          owner: '',
          chineseTitle: '',
          desc: '2022-02',
          imgUrl: require('../assets/img/research/research2.png')
        },
        {
          num: '3) ',
          text: '',
          title: 'The Design of Intelligent Responsive Sustained-release Materials.',
          owner: '',
          chineseTitle: '',
          desc: '2019-01',
          imgUrl: require('../assets/img/research/research3.png')
        }
      ],
      researchCenterOld: [
        {
          name: 'Abstract',
          num: '',
          text: 'Two series of dehydroabietyl-1,2,4-triazole-4-Schiff-based derivatives were synthesized from rosin to control plant fungal diseases. In vitro evaluation and screening of the antifungal activity were performed using Valsa mali, Colletotrichum orbiculare, Fusarium graminearum, Sclerotinia sclerotiorum, and Gaeumannomyces graminis. Compound 3f showed excellent fungicidal activity against V. mali (EC50 = 0.537 μg/mL), which was significantly more effective than the positive control fluconazole (EC50 = 4.707 μg/mL). Compound 3f also had a considerable protective effect against V. mali (61.57%–92.16%), which was slightly lower than that of fluconazole (85.17–100%) at 25–100 μg/mL. Through physiological and biochemical analyses, the preliminary mode of action of compound 3f against V. mali was explored. Ultrastructural observation of mycelia showed that compound 3f hindered the growth of the mycelium and destroyed the ultrastructure of V. mali seriously. Conductivity analysis and laser scanning confocal microscope staining showed that compound 3f changed cell-membrane permeability and caused accumulation of reactive oxygen species. The enzyme activity results showed that compound 3f significantly inhibited the activity of CYP51 (59.70%), SOD (76.9%), and CAT (67.86%). Molecular docking identified strong interaction energy between compound 3f and crystal structures of CYP51 (−11.18 kcal/mol), SOD (−9.25 kcal/mol), and CAT (−8.79 kcal/mol). These results provide guidance for the discovery of natural product-based antifungal pesticide candidates.',
          title: '',
          owner: '',
          chineseTitle: '药物的设计与合成',
          desc: '2022-01',
          imgUrl: require('../assets/img/banners_new/banner2.png')
        }
      ],
      researchLeftOld: {
        name: 'Abstract',
        num: '',
        text: 'Two series of dehydroabietyl-1,2,4-triazole-4-Schiff-based derivatives were synthesized from rosin to control plant fungal diseases. In vitro evaluation and screening of the antifungal activity were performed using Valsa mali, Colletotrichum orbiculare, Fusarium graminearum, Sclerotinia sclerotiorum, and Gaeumannomyces graminis. Compound 3f showed excellent fungicidal activity against V. mali (EC50 = 0.537 μg/mL), which was significantly more effective than the positive control fluconazole (EC50 = 4.707 μg/mL). Compound 3f also had a considerable protective effect against V. mali (61.57%–92.16%), which was slightly lower than that of fluconazole (85.17–100%) at 25–100 μg/mL. Through physiological and biochemical analyses, the preliminary mode of action of compound 3f against V. mali was explored. Ultrastructural observation of mycelia showed that compound 3f hindered the growth of the mycelium and destroyed the ultrastructure of V. mali seriously. Conductivity analysis and laser scanning confocal microscope staining showed that compound 3f changed cell-membrane permeability and caused accumulation of reactive oxygen species. The enzyme activity results showed that compound 3f significantly inhibited the activity of CYP51 (59.70%), SOD (76.9%), and CAT (67.86%). Molecular docking identified strong interaction energy between compound 3f and crystal structures of CYP51 (−11.18 kcal/mol), SOD (−9.25 kcal/mol), and CAT (−8.79 kcal/mol). These results provide guidance for the discovery of natural product-based antifungal pesticide candidates.',
        title: 'Design and Synthesis of Antifungal Candidates Containing Triazole Scaffold from Natural Rosin against Valsa mali for Crop Protection',
        owner: 'Renle Xu, Kun Chen, Xu Han, Yuhang Lou, Shihao Gu, Yanqing Gao*, Shibin Shang, Zhanqian Song, Jie Song, and Jian Li*',
        keywords: 'dehydroabietic acid; 1,2,4-triazole; antifungal activity; physiological biochemistry',
        chineseTitle: '药物的设计与合成',
        desc: '2022-01',
        imgUrl: require('../assets/img/research/research0.png')
      },
      researchRightOld: [
        {
          num: '1) ',
          text: '',
          title: 'Design and Synthesis of Rosin-Based Pesticides.',
          owner: '',
          chineseTitle: '',
          desc: '2022-02',
          imgUrl: require('../assets/img/research/research1.png')
        },
        {
          num: '2) ',
          text: '',
          title: 'The Design of Intelligent Responsive Sustained-release Materials.',
          owner: '',
          chineseTitle: '',
          desc: '2019-01',
          imgUrl: require('../assets/img/research/research2.png')
        }
      ],
      researchLeftList: [],
      researchRightList: []
    }
  },
  mounted () {
    this.getResearchList()
  },
  methods: {
    getResearchList () {
      this.$axios.get('/server_api/core/research/research_info')
        .then((response) => {
          let res = response.data
          if (res.code === 0) {
            let researchList = res.data.rows
            for (var i = 0; i < res.data.total; i++) {
              researchList[i].imgReqUrl = this.$getImgPath(researchList[i].imgPath)
              if (researchList[i].group === 'left') {
                this.researchLeftList.push(researchList[i])
              } else {
                this.researchRightList.push(researchList[i])
              }
            }
          } else {
            this.$message({
              message: '获取研究失败',
              type: 'error'
            })
          }
        })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/Research.vue